import React, { useState } from "react";

function Pagination({ currentPage, totalPages, onPageChange, loading }) {
    const [selectedPage, setSelectedPage] = useState(currentPage);

    const handleClick = (page) => {
        if (loading) return;
        setSelectedPage(page);
        onPageChange(page);
    };

    const getPageNumbers = () => {
        const pages = [];
        const first3 = [0, 1, 2];
        const last3 = [totalPages - 3, totalPages - 2, totalPages - 1];

        if (totalPages <= 7) {
            for (let i = 0; i < totalPages; i++) pages.push(i);
            return pages;
        }

        first3.forEach(p => pages.push(p));

        if (selectedPage <= 3) {
            pages.push(selectedPage === 3 ? 3 : null);
            if (!pages.includes("...")) pages.push("...");
        } else if (selectedPage >= totalPages - 4) {
            pages.push("...");
        } else {
            pages.push("...");
            pages.push(selectedPage);
            pages.push("...");
        }

        last3.forEach(p => {
            if (!pages.includes(p)) pages.push(p);
        });

        return pages.filter(p => p !== null);
    };

    if (totalPages <= 1) return null;

    return (
        <div className={`pagination-wrap ${loading ? "loading" : ""}`}>
            <button
                className="fbtn"
                onClick={() => handleClick(selectedPage - 1)}
                disabled={selectedPage === 0 || loading}
                style={{
                    opacity: selectedPage === 0 || loading ? 0.3 : 1,
                    cursor: loading ? "wait" : selectedPage === 0 ? "not-allowed" : "default"
                }}
            >
                ←
            </button>

            {getPageNumbers().map((page, index) =>
                page === "..." ? (
                    <span key={`dots-${index}`} className="pagination-dots">...</span>
                ) : (
                    <button
                        key={page}
                        className={`fbtn ${selectedPage === page ? "active" : ""}`}
                        onClick={() => handleClick(page)}
                        disabled={loading}
                        style={{
                            opacity: loading && selectedPage !== page ? 0.3 : 1,
                            cursor: loading ? "wait" : "default"
                        }}
                    >
                        {page + 1}
                    </button>
                )
            )}

            <button
                className="fbtn"
                onClick={() => handleClick(selectedPage + 1)}
                disabled={selectedPage === totalPages - 1 || loading}
                style={{
                    opacity: selectedPage === totalPages - 1 || loading ? 0.3 : 1,
                    cursor: loading ? "wait" : selectedPage === totalPages - 1 ? "not-allowed" : "default"
                }}
            >
                →
            </button>
        </div>
    );
}

export default Pagination;